import { defaultGlobalAccess } from "../../utils/create.workspace.utils";
import type { WorkspaceRoles } from "./types";

export function defaultRoles(): WorkspaceRoles {
  return {
    administrators: [],
    readers: [],
    writers: [],
    unspecifiedUsers: [],
    globalAccess: defaultGlobalAccess,
  };
}
